module.exports = __webpack_public_path__ + "img/features-2-costs.b2afe13d.png";